import { DeviceStatusIcons } from '@/features/devices/types/constants'
import { DeviceModel, DeviceStatus } from '@/features/devices/types/types'
import { ItemLayoutSkeleton } from '@/shared/components'
import { ConnectionButton } from '@/shared/components/ConnectionButton/ConnectionButton'
import { DeviceIcon } from '@/shared/components/icons/DeviceIcon'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { Skeleton } from '@/shared/components/shadcn'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
import { ActionButtons } from './ActionButtons'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'
import { getShortenId } from '@/shared/utils/getShortenId'

type Props = {
  device: DeviceModel
  isLoading: boolean
  onEdit: () => void
  onUpdateStatus: (id: string) => void
  onReassignDevice: () => void
}
export const DeviceHeader = ({
  device,
  onEdit,
  onUpdateStatus,
  onReassignDevice,
  isLoading,
}: Props) => {
  const isMobile = useIsMobile()

  const isActive = device.deviceStatus === DeviceStatus.Active
  const isDisabled = device.deviceStatus === DeviceStatus.Disabled

  const handleDeviceStatus = () => {
    if (isActive) onUpdateStatus(device.id)
    if (isDisabled) onUpdateStatus(device.id)
  }

  if (!isMobile) {
    return (
      <div className="flex justify-between items-start py-6 border-b border-b-card-border dark:border-b-card-border-dark">
        {isLoading ? (
          <>
            <ItemLayoutSkeleton />
            <div className="flex gap-x-4">
              <Skeleton className="w-[200px] h-10" />
              <Skeleton className="w-[200px] h-10" />
            </div>
          </>
        ) : (
          <>
            <ItemLayout
              icon={
                <DeviceIcon
                  status={DeviceStatusIcons[device.deviceStatus]}
                  className="w-[52px] h-[52px]"
                />
              }
              title={device.name}
              subtitle={
                <span className="flex gap-3">
                  <CopyBlock text={device.id} title={device.id}>
                    ID устройства: {getShortenId(device.id)}
                  </CopyBlock>
                  <ConnectionButton onClick={onReassignDevice} />
                </span>
              }
              titleClasses="text-[32px]"
            />
            <ActionButtons
              deviceStatus={device.deviceStatus}
              onEdit={onEdit}
              onToggleStatus={handleDeviceStatus}
            />
          </>
        )}
      </div>
    )
  } else {
    return (
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-[10px]">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-[10px]">
              <DeviceIcon status={DeviceStatusIcons[device.deviceStatus]} />
              <span className="font-klein font-medium text-text-secondary text-sm"></span>
            </div>
            <ConnectionButton onClick={onReassignDevice} />
          </div>
          {isLoading ? (
            <>
              <Skeleton className="w-2/3 h-6" />
              <Skeleton className="w-full h-8" />
            </>
          ) : (
            <div>
              <span className="font-klein font-medium text-[20px]">{device.name}</span>
              <CopyBlock text={device.id} title={device.id} color="secondary">
                ID устройства: {getShortenId(device.id)}
              </CopyBlock>
            </div>
          )}
        </div>
        {isLoading ? (
          <div className="flex justify-between gap-x-3">
            <Skeleton className="w-[200px] h-10" />
            <Skeleton className="w-[200px] h-10" />
          </div>
        ) : (
          <ActionButtons
            deviceStatus={device.deviceStatus}
            onEdit={onEdit}
            onToggleStatus={handleDeviceStatus}
          />
        )}
      </div>
    )
  }
}
